var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{class:[
    'preview',
    {
      bathroom: _vm.configurator.name === 'Bathroom',
      chair: _vm.configurator.name === 'Chair',
    } ]},[(_vm.image.url)?[_c('img',{staticClass:"base-img",attrs:{"src":_vm.image.url,"alt":"Base Image"}})]:_vm._e(),_c('img',{ref:"watermark",staticClass:"watermark",attrs:{"src":_vm.mycolourlogo,"alt":"Watermark"}}),_c('iframe',{attrs:{"id":"iframe"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }